import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import BookingsList from "@/components/sites/bookings/BookingsList";
import ShopOrders from "@/components/sites/shop/ShopOrders";
import ShopSubscriptions from "@/components/sites/shop/ShopSubscriptions";
import { Empty, can } from "@/components/crm/helpers";

function SitePicker({ tid, readOnly = true, children }) {
  const api = useApi();
  const [sites, setSites] = useState(null);
  const [cur, setCur] = useState("");
  useEffect(() => { api.get(`/t/${tid}/sites`, { params: { include_archived: true } }).then(({ data }) => { setSites(data); setCur(data[0]?.id || ""); }).catch((e) => { setSites([]); toast.error(errMsg(e)); }); }, [api, tid]);
  if (sites === null) return <p className="text-sm text-slate-500">Caricamento…</p>;
  if (!sites.length) return <Empty testid="area-no-sites">Nessun sito collegato a questo spazio.</Empty>;
  const site = sites.find((s) => s.id === cur) || sites[0];
  const label = (s) => `${s.name}${s.archived ? " (archiviato)" : ""}`;
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        {sites.length > 1 ? <Select value={site.id} onValueChange={setCur}><SelectTrigger className="h-9 w-64 bg-white text-sm" data-testid="area-site-select"><SelectValue /></SelectTrigger>
          <SelectContent>{sites.map((s) => <SelectItem key={s.id} value={s.id}>{label(s)}</SelectItem>)}</SelectContent></Select>
          : site.archived && <span className="text-xs text-slate-500" data-testid="area-site-archived">{label(site)}</span>}
        {site.archived ? <p className="text-xs text-slate-500" data-testid="area-archived-note">Sito archiviato: in sola lettura, le operazioni le esegue solo lo staff MUSORA.</p>
          : readOnly && <p className="text-xs text-slate-500" data-testid="area-readonly-note">Sola lettura: il tuo ruolo può vedere ma non modificare. Il titolare può cambiarlo in «Team e permessi».</p>}
      </div>
      {children(site)}
    </div>
  );
}

export function AreaBookings({ tid }) {
  return <div data-testid="area-bookings"><SitePicker tid={tid}>{(s) => <BookingsList key={s.id} tid={tid} siteId={s.id} readOnly />}</SitePicker></div>;
}

// Edit rights come from the server's effective permissions (owner matrix + «operations from the client area» switch).
export function AreaOrders({ tid, role }) {
  const edit = can(role, "shop.update");
  return <div data-testid="area-orders"><SitePicker tid={tid} readOnly={!edit}>{(s) => <ShopOrders key={s.id} tid={tid} site={s} role={role} readOnly={!edit} />}</SitePicker></div>;
}

export function AreaSubscriptions({ tid, role }) {
  const edit = can(role, "shop.update");
  return <div data-testid="area-subscriptions"><SitePicker tid={tid} readOnly={!edit}>{(s) => <ShopSubscriptions key={s.id} tid={tid} site={s} role={role} readOnly={!edit} />}</SitePicker></div>;
}
